import { render, staticRenderFns } from "./CopyField.vue?vue&type=template&id=1ead6f37&scoped=true&"
import script from "./CopyField.vue?vue&type=script&lang=js&"
export * from "./CopyField.vue?vue&type=script&lang=js&"
import style0 from "./CopyField.vue?vue&type=style&index=0&id=1ead6f37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ead6f37",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
